var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_9099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6275 18.6275 24 12 24C5.37255 24 0 18.6275 0 12C0 5.37255 5.37255 0 12 0C18.6275 0 24 5.37255 24 12ZM11.6004 5.38103C7.75941 5.71807 6.5098 10.4176 9.63752 12.5808C11.5782 13.9226 14.744 13.1828 15.6693 10.9327C16.8479 8.06571 14.6603 5.11288 11.6004 5.38103ZM14.4409 15.7795C11.9311 13.8548 7.87599 15.5188 7.91309 18.8098L15.9682 18.9147C15.9036 17.681 15.4308 16.5384 14.4409 15.7795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.602 5.38027C14.6619 5.11212 16.8495 8.06496 15.6709 10.9319C14.7457 13.1821 11.5798 13.9219 9.63913 12.5801C6.51142 10.4168 7.76102 5.71731 11.602 5.38027Z",
    fill: "#2469B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4421 15.7779C15.4321 16.5368 15.9037 17.6804 15.9694 18.913L7.91432 18.8081C7.87722 15.5172 11.9323 13.8531 14.4421 15.7779Z",
    fill: "#2469B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_9099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpidIcon);
export default __webpack_public_path__ + "static/media/spid-icon.435938ee73942d71a10319854396a6b7.svg";
export { ForwardRef as ReactComponent };